/**
 * @generated SignedSource<<f0897d04c4b4a9d3c12e3425c3a7004e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Category_Fragment$data = {
  readonly categories: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly children: {
          readonly __id: string;
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly count: number | null | undefined;
              readonly id: string;
              readonly name: string | null | undefined;
              readonly znglycategory: {
                readonly pinnedContent: ReadonlyArray<{
                  readonly id?: string;
                  readonly title?: string | null | undefined;
                } | null | undefined> | null | undefined;
                readonly uxOrder: number | null | undefined;
              } | null | undefined;
            };
          }>;
        } | null | undefined;
        readonly count: number | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
        readonly znglycategory: {
          readonly pinnedContent: ReadonlyArray<{
            readonly id?: string;
            readonly title?: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly uxOrder: number | null | undefined;
        } | null | undefined;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "Category_Fragment";
};
export type Category_Fragment$key = {
  readonly " $data"?: Category_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"Category_Fragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Category_Znglycategory",
  "kind": "LinkedField",
  "name": "znglycategory",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uxOrder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "pinnedContent",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "type": "ZnglyVideo",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "categories"
        ]
      }
    ]
  },
  "name": "Category_Fragment",
  "selections": [
    {
      "alias": "categories",
      "args": [
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "childless": false,
            "hierarchical": true,
            "parent": null
          }
        }
      ],
      "concreteType": "RootQueryToCategoryConnection",
      "kind": "LinkedField",
      "name": "__CategoriesComponent_query__categories_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RootQueryToCategoryConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Category",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 1000
                    }
                  ],
                  "concreteType": "CategoryToCategoryConnection",
                  "kind": "LinkedField",
                  "name": "children",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CategoryToCategoryConnectionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Category",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v1/*: any*/),
                            (v2/*: any*/),
                            (v3/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v4/*: any*/)
                  ],
                  "storageKey": "children(first:1000)"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RootQueryToCategoryConnectionPageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": "__CategoriesComponent_query__categories_connection(where:{\"childless\":false,\"hierarchical\":true,\"parent\":null})"
    }
  ],
  "type": "RootQuery",
  "abstractKey": null
};
})();

(node as any).hash = "e8612116e0178d6937b66405b71a38b4";

export default node;
